import { SetStateAction, useCallback, useState } from "react";

type IUseLocalStorageData<T> = [
    T,
    (value: SetStateAction<T>) => void
];


export const getState = <T>(key: string): T | undefined => {
    try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : undefined;
    } catch (error) {
        //  console.info(error);
        window.localStorage.removeItem(key);
        return undefined;
    }
};


export const setState = <T>(key: string, setFn: SetStateAction<T | undefined>) => {
    if (!setFn) { console.warn("[useLocalStorage.setValue]: no value provided"); }
    try {
        const state = getState<T>(key);
        const valueToStore = setFn instanceof Function ? setFn(state) : setFn;
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
        //  console.info(error);
    }
}



export const useLocalStorage = <T>(key: string, initialValue: T): IUseLocalStorageData<T> => {

    const [storedValue, setStoredValue] = useState<T>(getState(key) ?? initialValue);

    const setValue = useCallback((value: SetStateAction<T>) => {
        if (!value) { console.warn("[useLocalStorage.setValue]: no value provided"); }
        try {

            setStoredValue((prev) => {
                // Allow value to be a function so we have same API as useState
                const valueToStore = value instanceof Function ? value(prev) : value;
                window.localStorage.setItem(key, JSON.stringify(valueToStore));

                return valueToStore;
            });

        } catch (error) {
            //  console.info(error);
        }
    }, [key]);

    return [storedValue, setValue];
};